import React, { useEffect, useRef, useState } from "react";
import styles from "./UpcomingEventsSection.module.css";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const UpcomingEventsSection = () => {
  const rowsRef = useRef([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        // Get today's date in YYYY-MM-DD format (local time)
        const now = new Date();
        const todayString = now.getFullYear() + '-' + 
                            String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                            String(now.getDate()).padStart(2, '0');

        const q = query(
          collection(db, "events"),
          where("status", "==", "published")
        );

        const snapshot = await getDocs(q);
        const eventsData = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          // HIDE PAST EVENTS: Only show if event date is today or later
          .filter((event) => event.date >= todayString)
          // Sort by date so the soonest event is first
          .sort((a, b) => a.date.localeCompare(b.date));

        setEvents(eventsData);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, []);

  const handleBookNow = (url) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      alert("Booking link not available for this event.");
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.show);
          }
        });
      },
      { threshold: 0.1 }
    );

    rowsRef.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, [events]);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>UPCOMING EVENTS</h2>
        <div className={styles.divider2}></div>

        <div className={styles.list}>
          {events.length > 0 ? (
            events.map((event, index) => {
              const eventDate = event.date ? new Date(event.date) : null;

              return (
                <div
                  key={event.id}
                  ref={(el) => (rowsRef.current[index] = el)}
                  className={styles.eventCard}
                  style={{ transitionDelay: `${index * 120}ms` }}
                >
                  <div className={styles.dateBox}>
                    <span>
                      {eventDate?.toLocaleDateString("en-US", {
                        weekday: "long",
                      })}
                    </span>
                    <strong>
                      {eventDate?.toLocaleDateString("en-US", {
                        day: "2-digit",
                        month: "short",
                      })}
                    </strong>
                  </div>

                  <div className={styles.imageWrap}>
                    <img 
                      src={`${event.imageUrl}?v=1`} 
                      alt={event.title} 
                      loading="lazy" 
                    />
                  </div>

                  <div className={styles.content}>
                    <h3>{event.title}</h3>
                    <p>{event.description}</p>

                    <div className={styles.tags}>
                      {event.tags?.map((tag, i) => (
                        <span key={i}>{tag}</span>
                      ))}
                    </div>

                    <div className={styles.bottom}>
                      <button onClick={() => handleBookNow(event.bookingUrl)}>
                        Book Now
                      </button>
                      <span className={styles.price}>
                        Starting @ ₹{event.price}
                      </span>
                    </div>
                  </div>

                  <span className={styles.divider}></span>
                </div>
              );
            })
          ) : (
            <p className={styles.noEvents}>No upcoming events scheduled at the moment.</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default UpcomingEventsSection;